import Vue from 'vue';
import VueRouter from 'vue-router';
import ElementUI from 'element-ui';
import VueScrollactive from 'vue-scrollactive';
import VueCookies from 'vue-cookies';
import 'element-ui/lib/theme-chalk/index.css';


import App from './App.vue';
import { router } from './router/index.js';



Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.use(VueScrollactive);
Vue.use(VueCookies);

new Vue({ el: '#app', router, render: h => h(App) });

